<template>
  <v-card flat>
    <v-col cols="12" class="px-0 pt-0">
      <v-btn color="primary" icon @click="handleBackOptions">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pages.video.metricsPage.liveRetention') }}
      </span>
    </v-col>
    <v-row no-gutters class="py-0 px-2">
      <v-col cols="12">
        <v-card flat>
          <span>
            {{ $t('message.pages.video.metricsPage.liveRetentionMessage') }}
          </span>
        </v-card>
      </v-col>
    </v-row>
    <!--<v-row class="px-2">
      <v-col cols="12" v-if="liveInfo.started_at && endedDate" class="d-flex align-center">
        <b>{{ startedDate }}</b><br />
        <v-divider class="mx-2"></v-divider>
        <v-icon>mdi-progress-clock</v-icon>
        <v-divider class="mx-2"></v-divider>
        <span v-if="endedDate"><b>{{ endedDate }}</b></span>
      </v-col>
    </v-row>-->
    <v-row>
      <v-col class="col-graph pa-0 pt-3">
        <live-graph
          :viewsPerMinute="liveInfo.view_metrics.views"
          :uniqueViews="liveInfo.view_metrics.unique_views"
          style="box-shadow: none"
          v-if="checkLiveRetention() === true"
          class="mt-5"
        />
        <v-row
          align="center"
          class="mt-5"
          justify="center"
          v-else-if="liveInfo.started_at"
        >
          <p
            class="text-center ma-0 px-7"
            style="color: #d6d6d6; font-weight: 600"
          >
            {{ $t('message.pages.newLive.metricsMessage') }}
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { format } from 'date-fns'
import LiveGraph from '@/components/LiveGraph.vue'

export default {
  name: 'LiveStatus',
  components: { LiveGraph },
  props: {
    serverStatus: {
      required: true,
    },
    timeLeft: {
      required: true,
    },
    viewers: {
      required: false,
    },
    errors: {
      required: true,
    },
    liveInfo: {
      required: true,
    },
    lastVerificationServer: {
      required: false,
    },
    customVideoId: {
      required: true,
    },
    isStreamingRightNow: {
      required: true,
    },
    handleBackOptions: {
      required: true,
    },
  },
  methods: {
    checkLiveRetention() {
      if (Object.keys(this.liveInfo.view_metrics).length > 0) {
        if (this.liveInfo.view_metrics.duration !== 0) {
          if (this.liveInfo.view_metrics.duration < 0) {
            this.liveInfo.view_metrics.duration =
              this.liveInfo.view_metrics.duration * -1
          }
          return true
        }
      }
    },
  },
  data: () => ({}),
  computed: {
    startedDate() {
      return format(new Date(this.liveInfo.started_at), 'dd/MM/yyyy HH:mm')
    },
    endedDate() {
      if (this.liveInfo.ended_at) {
        return format(new Date(this.liveInfo.ended_at), 'dd/MM/yyyy HH:mm')
      } else {
        return false
      }
    },
  },
}
</script>
